/**
 * 
 * Text Field
 * 
 */

 import React, { useState } from 'react'
 import PropTypes from 'prop-types'
 import { Label, Input, FormGroup } from 'reactstrap'

 import OtpPopup  from './otpPopup.js'
 
 function MobileotpField (props) {
         const { label, name, value, placeholder, onChange, isInvalid, required, style, disabled,classval } = props
        
        const [openModal, setOpenModal] = useState(false)
         return (
             <React.Fragment >
                 <FormGroup className='no-margin'>
                     <Label className={classval} htmlFor={name}>{label} {required ? <span style={{color: 'red'}}>*</span> : null}</Label>
                     <Input
                         type="text"
                         className="form-control"
                         name={name}
                         value={value}
                         onChange={onChange}
                         id={name}
                         style={style}
                         disabled={disabled}
                         placeholder={placeholder}
                         invalid={isInvalid ? true : false}
                     />
                     

                     {!openModal ? <span onClick={() => setOpenModal(!openModal)}>Need to Verify ?</span>: null}
                    {openModal ? <OtpPopup></OtpPopup>: null}
                 </FormGroup>
             </React.Fragment>
         )
 }
 
 MobileotpField.propTypes = {
     t: PropTypes.any,
     label: PropTypes.string,
     value: PropTypes.string,
     name: PropTypes.string,
     onChange: PropTypes.func,
     placeholder: PropTypes.string,
     isInvalid: PropTypes.any,
     required: PropTypes.bool,
     style: PropTypes.object,
     disabled: PropTypes.any,
     classval:PropTypes.string
 }
 
 export default MobileotpField
 